import {
	CHANGE_LOGIN_EMAIL,
	CHANGE_LOGIN_PASSWORD,
	LOGIN_SUCCESS,
	LOGOUT_SUCCESS,
	LOAD_USER_FROM_LOCAL_STORAGE,
	UPDATE_PROFILE_SUCCESS,
	USER_CAN_ACCESS_POS_SETTINGS,
	USER_CAN_PAUSE_ALL_RESTAURANTS
} from '../../actions/types';

const INITIAL_STATE = {
	id: -1,
	email: '',
	password: '',
	token: '',
	name: '',
	phone: '',
	language: '',
	role: '',
	countryCode: '',
	canAccessPosSettings: false,
	canAccessPauseAllRestaurants: false
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case CHANGE_LOGIN_EMAIL:
			return { ...state, email: action.payload };
		case CHANGE_LOGIN_PASSWORD:
			return { ...state, password: action.payload };
		case LOGIN_SUCCESS:
			const response = action.payload;
			const user = response.data[0];

			return {
				...state,
				password: '', // clear password so that we do not keep it the browser
				token: response.token,
				id: user.id,
				name: user.name,
				phone: user.phone,
				language: user.language,
				role: user.role,
				countryCode: user.countryCode,
				canAccessPosSettings: false,
				canAccessPauseAllRestaurants: false
			};
		case UPDATE_PROFILE_SUCCESS:
			const updatedUser = action.payload;
			return {
				...state,
				name: updatedUser.name,
				email: updatedUser.email,
				phone: updatedUser.phone,
				language: updatedUser.language,
				countryCode: updatedUser.countryCode
			};
		case LOGOUT_SUCCESS:
			return INITIAL_STATE;
		case LOAD_USER_FROM_LOCAL_STORAGE:
			return action.payload;
		case USER_CAN_ACCESS_POS_SETTINGS:
            return {
                ...state,
                canAccessPosSettings:action.payload
			};
		case USER_CAN_PAUSE_ALL_RESTAURANTS:
			return {
				...state,
				canAccessPauseAllRestaurants: action.payload
			}	
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/users/UserReducer.js